// Generated by scripts/write-yacht-replay-fixtures.ts.
// Do not edit manually.

import type { YachtReplayEventType } from "./event-adapter";

export interface YachtReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface YachtReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: YachtReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface YachtReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "yacht";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly seed: string;
  readonly observerUserId: string;
  readonly players: readonly YachtReplayFixturePlayer[];
  readonly events: readonly YachtReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const YACHT_REPLAY_FIXTURES: Record<
  string,
  YachtReplayFixture
> = {
  "simple-2p-live": {
    "schemaVersion": 1,
    "gameType": "yacht",
    "scenario": "simple-2p-live",
    "source": "generated",
    "capturedAt": "2026-06-12T00:00:00.000Z",
    "seed": "yacht:replay:simple-2p-live",
    "observerUserId": "observer",
    "players": [
      {
        "id": "p1",
        "name": "Joon",
        "role": "host"
      },
      {
        "id": "p2",
        "name": "Mina",
        "role": "player"
      }
    ],
    "events": [
      {
        "sequenceNumber": 1,
        "eventType": "init",
        "userId": "p1",
        "payload": {
          "state": {
            "gameId": "yacht-replay-simple-2p-live",
            "phase": "ROLLING",
            "turnMode": "SEQUENTIAL",
            "gameSeed": "yacht:replay:simple-2p-live",
            "sheetRound": 1,
            "turnNumber": 1,
            "players": [
              {
                "playerId": "p1",
                "displayName": "Joon"
              },
              {
                "playerId": "p2",
                "displayName": "Mina"
              }
            ],
            "seatingOrder": [
              "p1",
              "p2"
            ],
            "turnSlotsByPlayerId": {
              "p1": {
                "turnNumber": 1,
                "sheetRound": 1,
                "playerId": "p1",
                "dice": [
                  null,
                  null,
                  null,
                  null,
                  null
                ],
                "held": [
                  false,
                  false,
                  false,
                  false,
                  false
                ],
                "rollCount": 0,
                "status": "OPEN",
                "rngState": {
                  "algorithm": "mulberry32",
                  "streamId": "yacht:replay:simple-2p-live:p1:1",
                  "state": 6746179
                }
              }
            },
            "scoreSheetsByPlayerId": {
              "p1": {
                "playerId": "p1",
                "entries": {},
                "upperSubtotal": 0,
                "upperBonus": 0,
                "lowerSubtotal": 0,
                "total": 0
              },
              "p2": {
                "playerId": "p2",
                "entries": {},
                "upperSubtotal": 0,
                "upperBonus": 0,
                "lowerSubtotal": 0,
                "total": 0
              }
            }
          }
        }
      },
      {
        "sequenceNumber": 2,
        "eventType": "SyncViewerState",
        "userId": "p1",
        "payload": {
          "actionId": "simple-2p-live:sync-initial-view"
        }
      },
      {
        "sequenceNumber": 3,
        "eventType": "ROLL_DICE",
        "userId": "p1",
        "payload": {
          "sheetRound": 1,
          "turnNumber": 1
        }
      },
      {
        "sequenceNumber": 4,
        "eventType": "TOGGLE_HOLD",
        "userId": "p1",
        "payload": {
          "sheetRound": 1,
          "turnNumber": 1,
          "dieIndex": 0
        }
      },
      {
        "sequenceNumber": 5,
        "eventType": "ROLL_DICE",
        "userId": "p1",
        "payload": {
          "sheetRound": 1,
          "turnNumber": 1
        }
      },
      {
        "sequenceNumber": 6,
        "eventType": "SCORE_CATEGORY",
        "userId": "p1",
        "payload": {
          "sheetRound": 1,
          "turnNumber": 1,
          "category": "ONES"
        }
      },
      {
        "sequenceNumber": 7,
        "eventType": "ROLL_DICE",
        "userId": "p2",
        "payload": {
          "sheetRound": 1,
          "turnNumber": 2
        }
      },
      {
        "sequenceNumber": 8,
        "eventType": "SCORE_CATEGORY",
        "userId": "p2",
        "payload": {
          "sheetRound": 1,
          "turnNumber": 2,
          "category": "CHOICE"
        }
      }
    ],
    "notes": [
      "Yacht replay fixtures use full canonical init state plus public action commands so the replay runner can verify seeded dice through the engine reducer.",
      "Live persisted Yacht events are intentionally redacted to private_action; the replay fixture is for deterministic local review and route smoke coverage.",
      "Observer snapshots are projected from engine state and must not expose gameSeed, rngState, streamId, or other random internals."
    ]
  }
};
